module.exports = __webpack_public_path__ + "img/favourite.2abc7edb.svg";